import React, { FC } from 'react';

import styles from './ForcePublishDialog.module.scss';

type Props = {
  handleSubmit: () => void;
};

const ForcePublishDialog: FC<Props> = ({ handleSubmit }) => {
  return (
    <div className={styles.dialog_inner}>
      <p className={styles.dialog_alert_text}>会社ページ運営公開を実行します。よろしいですか？</p>
      <button className={styles.confirm_button} onClick={() => handleSubmit()}>
        実行する
      </button>
    </div>
  );
};

export default ForcePublishDialog;
